import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomPersonAdd = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M9 20h13v-3c0-2.66-5.33-4-8-4-.986 0-2.334.183-3.642.547A5 5 0 1 0 9 20m11.1-3c0-.64-3.13-2.1-6.1-2.1-1.042 0-2.104.18-3.043.44q.043.325.043.66a5 5 0 0 1-.461 2.1H20.1zM6.875 15.125V12.5h-1.75v2.625H2.5v1.75h2.625V19.5h1.75v-2.625H9.5v-1.75zM10 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4m6.1 0a2.1 2.1 0 1 0-4.2 0 2.1 2.1 0 0 0 4.2 0"
  />,
  'CustomPersonAdd',
);

export default CustomPersonAdd;
